import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';

export const insertDatasetData = (
  api: string,
  //TODO: Create body type
  body: any,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(
    resolveApiPath(api),
    'POST',
    token,
    forceHeader,
    undefined,
    body
  );
